import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';

export default class KuposSteps extends Component {
  static propTypes = {
    menuButtons: PropTypes.array,
    t: PropTypes.func,
    onStepClick: PropTypes.func,
  };

  render() {
    const { t } = this.props;
    // console.log(t)
    const operator = CommonService.getLocal('op');
    return (
      <div className="common-kupos-steps kupos-steps"  style={{ marginTop: operator && operator.theme_type == 9 ? '170px' : '' }}>
        <style>
          a.kupos-step-item.active:after {'{'}
          background-color:{' '}
          {operator && operator.color_codes 
            ? operator.operator_name === 'busnorte' ? operator.color_codes.header_color:operator.color_codes.secondary_color
            : '#ff5c60'}
          ;{'}'}
        </style>

        {this.props.menuButtons
          ? this.props.menuButtons.map((value, key) => {
              return (
                <a
                  className={'kupos-step-item font10 ' + (value.active ? 'active' : '')}
                  key={key}
                  onClick={() => (this.props.onStepClick ? this.props.onStepClick(key + 1) : null)}
                  style={
                    value.active
                      ? operator && operator.operator_name === 'busnorte'
                        ? { backgroundColor: operator.color_codes.header_color }
                        : operator && operator.color_codes && operator.color_codes.secondary_color
                        ? { backgroundColor: operator.color_codes.secondary_color }
                        : {}
                      : {}
                  }
                >
                  <span className="step-number">{key + 1}</span>
                  <span className={'step-label '}>{t('PASSENGER_DETAILS.' + value.label)}</span>
                </a>
              );
            })
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposSteps.js